import { InputHTMLAttributes, forwardRef } from "react";
import { clsx } from "clsx";

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(({ className, ...props }, ref) => (
  <input
    ref={ref}
    className={clsx("h-10 w-full rounded-md border border-border bg-card px-3 text-sm text-text placeholder:text-dim focus:border-brand-500 focus:ring-2 focus:ring-brand-500/20 dark:border-border-dark dark:bg-card-dark dark:text-text-dark", className)}
    {...props}
  />
));
Input.displayName = "Input";
